import { LogoutOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, type MenuProps, Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EAbilityActions, EAbilitySubjects } from '@client/hooks/useAbilities';
import { useAuth } from '@client/hooks/useAuth';

export const ProfileMenu: React.FC = (): React.JSX.Element => {
  const { ability, user, signOut } = useAuth();
  const { t } = useTranslation();

  const items: MenuProps['items'] = [
    {
      key: 'login',
      label: (
        <>
          <span>Last login at</span>
          <br />
          {user?.metadata.lastSignInTime}
        </>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      label: t('actions.logout'),
      key: '4',
      danger: true,
      disabled: ability.cannot(EAbilityActions.READ, EAbilitySubjects.LOGOUT),
      icon: <LogoutOutlined />,
      onClick: signOut,
    },
  ];

  const menuProps = { items };

  return (
    <Space.Compact>
      <Dropdown menu={menuProps} trigger={['click']}>
        <Button
          type="text"
          icon={
            <Avatar
              src={user?.photoURL || undefined}
              alt={user?.displayName || ''}
            />
          }
        >
          {user?.displayName}
        </Button>
      </Dropdown>
    </Space.Compact>
  );
};
